// Lives in a .ts file so Fast Refresh isn't invalidated by mixed exports in the .tsx Provider.
import { useContext } from "react";
import type { UseAuthReturn } from "@/types/auth";
import { AuthContext } from "@/hooks/authContext";

/**
 * Consume shared auth state. All 22+ call-sites share a single provider
 * instance, so the token exchange effect fires only once on login.
 */
export function useAuth(): UseAuthReturn {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth() called outside <AuthProvider>. Wrap your app in <AuthProvider>.");
  }
  return ctx;
}
